import { render, staticRenderFns } from "./EventPreviewCard.vue?vue&type=template&id=eaf8079a&scoped=true&"
import script from "./EventPreviewCard.vue?vue&type=script&lang=js&"
export * from "./EventPreviewCard.vue?vue&type=script&lang=js&"
import style0 from "./EventPreviewCard.vue?vue&type=style&index=0&id=eaf8079a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaf8079a",
  null
  
)

export default component.exports